import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Пликове за завивки ранфорс 100% памук | Размери по поръчка | GoToBed',
  description:
    'Пликове за завивки от ранфорс 100% памук. Едноцветни и шарени, стандартни и нестандартни размери. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Пликове за завивки ранфорс – 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Пликове за завивки ранфорс от 100% памук
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете пликове за завивки от ранфорс – 100% памук, които се
          отличават със здравина, добра проветривост и комфорт при ежедневна употреба. Ранфорсът е
          една от най-предпочитаните материи за спално бельо, защото съчетава издръжливост, мекота и
          естествена дишаемост. Нашето основно предимство е богатият избор от размери, което
          позволява лесно да изберете подходящ ранфорс плик за завивка за всяка завивка – независимо
          дали е стандартна или нестандартна. Тук ще намерите голямо разнообразие от размери, сред
          които популярните 140/200, 150/220, 180/200, 200/200, 200/220 и 250/230, което улеснява
          избора на точния плик за вашата завивка. В колекцията ще откриете както едноцветни пликове
          за завивки, така и шарени модели с принт, които създават уют и стил в спалнята.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
      {introExpanded && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Ако търсите цялостно решение за спалнята, можете да разгледате и:
          </Typography>
          <Box sx={{ mb: 2, pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/kalufki/1/2/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              калъфки за възглавници ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/charshafi/1/1/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              чаршафи ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              чаршафи с ластик ранфорс
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyPlikoveRanfors />;
}

function SeoBodyPlikoveRanfors() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Пликове за завивки от ранфорс – здрав и дишащ памучен плат */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Пликове за завивки от ранфорс – здрав и дишащ памучен плат
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Пликовете за завивки от ранфорс са отличен избор за хората, които търсят здрав, удобен и
        дишащ памучен плат за своето спално бельо.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ранфорсът е 100% памучна тъкан, която се отличава с:
      </Typography>
      <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
        <li>добра издръжливост</li>
        <li>приятна и гладка структура</li>
        <li>комфорт по време на сън</li>
      </Box>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Пликовете за завивки от ранфорс са:
      </Typography>
      <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
        <li>лесни за поддръжка</li>
        <li>устойчиви на многократно пране</li>
        <li>подходящи за използване през всички сезони</li>
      </Box>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички продукти се изработват в България от висококачествени памучни платове със сертификат
        OEKO-TEX Standard 100, който гарантира безопасност и високо качество на текстила.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако се интересувате и от други памучни материи за спално бельо, разгледайте:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки от 100% памук
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Пликове за завивки от ранфорс в много размери */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Пликове за завивки от ранфорс в много размери
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите пликове за завивки от ранфорс е голямото
          разнообразие от размери.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          При поръчка можете да изберете параметрите на плика според размера на вашата завивка:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            ширина: от 120 до 300 см
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            дължина: от 190 до 230 см
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Сред най-предпочитаните размери са плик за завивка 140/200, плик за завивка 150/220, плик
          за завивка 180/200, плик за завивка 200/200 и плик за завивка 200/220.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Това позволява лесно да намерите подходящ плик за завивка от ранфорс за:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
          <li>единични легла</li>
          <li>стандартни двойни легла</li>
          <li>големи семейни завивки</li>
          <li>нестандартни размери</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Ако не намирате точния размер в стандартните магазини, нашите пликове за завивки по размер
          са практично и удобно решение.
        </Typography>

        {/* H2: Популярни размери пликове за завивки от ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери пликове за завивки от ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-търсените размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            'плик за завивка 140/200 (140x200) см',
            'плик за завивка 150/220 (150x220) см',
            'плик за завивка 180/200 (180x200) см',
            'плик за завивка 200/200 (200x200) см',
            'плик за завивка 200/220 (200x220) см',
            'плик за завивка 240/220 (240x220) см',
            'плик за завивка 250/230 (250x230) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тези размери са подходящи както за единични легла, така и за големи двойни легла и семейни
          завивки.
        </Typography>

        {/* H2: Какво представлява платът ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява платът ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е плътна памучна тъкан, изработена от 100% естествени влакна. Този плат е много
          популярен при спалното бельо, защото съчетава комфорт, здравина и дълготрайност.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Основни предимства на ранфорса:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
          <li>&#10004; 100% памук</li>
          <li>&#10004; добра дишаемост</li>
          <li>&#10004; висока издръжливост при пране</li>
          <li>&#10004; приятна на допир материя</li>
          <li>&#10004; подходящ за използване през всички сезони</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Затова пликовете за завивки от ранфорс са практичен избор за хората, които търсят
          качествено и устойчиво спално бельо.
        </Typography>

        {/* H2: Предимства на нашите пликове за завивки от ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите пликове за завивки от ранфорс
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 4 }}>
          <li>&#10004; изработени от 100% памук ранфорс</li>
          <li>&#10004; голямо разнообразие от размери</li>
          <li>&#10004; ширина от 120 до 300 см</li>
          <li>&#10004; дължина от 190 до 230 см</li>
          <li>&#10004; подходящи за стандартни и нестандартни завивки</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; произведени в България</li>
        </Box>

        {/* H2: Още продукти за вашата спалня */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Още продукти за вашата спалня
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да създадете напълно завършен комплект спално бельо ранфорс, можете да комбинирате
          плика за завивка с:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi/1/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик ранфорс
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Така лесно можете да съчетаете плик за завивка, чаршаф и калъфки в един стил и да
          създадете уютна и хармонична спалня.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за пликове за завивки ранфорс
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какво представлява платът ранфорс?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Ранфорсът е 100% памучен плат, който се отличава с по-голяма плътност и издръжливост в
            сравнение с много стандартни памучни материи. Благодарение на това той е много подходящ
            за спално бельо и пликове за завивки, защото осигурява добра дишаемост, комфорт и
            устойчивост при пране.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер плик за завивка от ранфорс?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            За да изберете подходящ плик за завивка от ранфорс, измерете ширината и дължината на
            вашата завивка или одеяло. След това изберете плик със същия или близък размер.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            В нашия магазин можете да изберете размер със следните параметри:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>ширина: 120 – 300 см</li>
            <li>дължина: 190 – 230 см</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са пликовете от ранфорс за големи завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Благодарение на голямото разнообразие от размери пликовете за завивки от ранфорс са
            подходящи както за стандартни, така и за големи двойни и семейни завивки.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свива ли се пликът за завивка от ранфорс след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и пликовете за завивки от ранфорс могат да имат
            естествена свиваемост около 4–5% след първите пранета. Това е нормално свойство на
            памучните материи.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Каква е разликата между ранфорс и памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            И двата плата са 100% памук, но имат различна структура.
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>Ранфорс – по-плътен и издръжлив плат, подходящ за ежедневна употреба.</li>
            <li>Памучен сатен – по-гладък и фин плат с лек блясък и по-луксозно усещане.</li>
          </Box>
          <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary' }}>
            Ако предпочитате по-фин текстил, можете да разгледате:
          </Typography>
          <Box sx={{ mt: 1, pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки памучен сатен
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват пликовете за завивки от ранфорс?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички пликове за завивки от ранфорс се изработват в България, специално за всяка
            поръчка и според избраните размери.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Колко време отнема изработката?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Срокът за изработка е 3 – 10 работни дни, като в повечето случаи поръчките са готови в
            рамките на 4 – 7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
